import React from 'react';
import { FormattedMessage } from 'react-intl';

function TableHead(props) {
  return (
    <thead className="thead-light">
      <tr>
        <th
          className="template"
          data-sort="template"
          scope="col"
          onClick={ () => props.applySort('template') }
        >
          <FormattedMessage id="components.pages.emailCampaigns.table.template" />
        </th>
        <th
          className="recipients"
          data-sort="recipients"
          scope="col"
          onClick={ () => props.applySort('recipients') }
        >
          <FormattedMessage id="components.pages.emailCampaigns.table.recipients" />
        </th>
        <th
          className="status"
          data-sort="status"
          scope="col"
          onClick={ () => props.applySort('status') }
        >
          <FormattedMessage id="components.pages.emailCampaigns.table.status" />
        </th>
        <th
          className="created_at"
          data-sort="created_at"
          scope="col"
          onClick={ () => props.applySort('created_at') }
        >
          <FormattedMessage id="components.pages.emailCampaigns.table.created_at" />
        </th>

        <th
          scope="row"
          className="w-10"
        >
          <FormattedMessage id="components.pages.emailCampaigns.table.actions" />
        </th>
      </tr>
    </thead>
  )
}

export { TableHead };
